import { UsersRepo } from '@services/users.repo'
class ContactUs {

  /** @ngInject */
  constructor(private usersRepo: UsersRepo, private $window: angular.IWindowService) {

  }

  getTermsAndConditions = () => {
    this.usersRepo.getTermsAndConditions()
      .then(res => {
        let terms = res.data as any;
        this.$window.open(terms.url, '_blank');
      }
      );

  }


}

export const contactus: angular.IComponentOptions = {
  template: require('./contactus.html'),
  controller: ContactUs

}



// WEBPACK FOOTER //
// ./src/app/contactus/contactus.ts